import { render } from "./DefaultRichMenuModal.vue?vue&type=template&id=795cbaf3&scoped=true"
import script from "./DefaultRichMenuModal.vue?vue&type=script&lang=ts"
export * from "./DefaultRichMenuModal.vue?vue&type=script&lang=ts"

import "./DefaultRichMenuModal.vue?vue&type=style&index=0&id=795cbaf3&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-795cbaf3"

export default script
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QToolbar,QToolbarTitle,QBtn,QCardSection,QInput,QIcon,QSeparator,QSpace});
